import React from 'react';
import { useIsEmbeddedMobile } from '../../../_hooks/useIsEmbeddedMobile';
import { EmptyState } from '../../../CommonComponents/OPL/AsyncStates/EmptyState/EmptyState';
import { ErrorState } from '../../../CommonComponents/OPL/AsyncStates/ErrorState/ErrorState';
import { Box } from '../../../CommonComponents/OPL/Box/Box';
import { ColumnChartLoading } from '../../../CommonComponents/OPL/charts/ColumnChart/ColumnChart.loading';
import { Text } from '../../../CommonComponents/OPL/Text/Text';
import { usePerformanceChartCard } from '../../hooks/usePerformanceChart';
import { PerformanceChartContent } from './components/PerformanceChartContent/PerformanceChartContent';
import { CHART_HEIGHT } from './PerformanceChart.meta';

interface Props {
  title: string;
}

export const PerformanceChart = ({ title }: Props) => {
  const isEmbeddedMobile = useIsEmbeddedMobile();

  return (
    <Box display="flex" flexDirection="column" height="100%">
      {isEmbeddedMobile && (
        <Box mx="16">
          <Text variant="smallCaps" mt="24">
            {title}
          </Text>
        </Box>
      )}

      <PerformanceChartLoader />
    </Box>
  );
};

const PerformanceChartLoader = () => {
  const { data, isFetching, error, refetch } = usePerformanceChartCard();

  const isEmbeddedMobile = useIsEmbeddedMobile();

  if (isFetching) {
    return (
      <ColumnChartLoading
        isStacked={false}
        categoriesCount={1}
        chartHeight={isEmbeddedMobile ? CHART_HEIGHT : 280}
      />
    );
  }

  if (error) {
    return (
      <Box display="flex" alignItems="center" justifyContent="center" py="24" height="100%">
        <ErrorState onAction={refetch} />
      </Box>
    );
  }

  if (!data || (data && data.categories.length === 0)) {
    return (
      <Box height="100%" display="flex" alignItems="center" justifyContent="center" py="56">
        <EmptyState />
      </Box>
    );
  }

  return <PerformanceChartContent data={data} />;
};
